<div class="loading-container" [ngClass]="{ 'hide-loading': !display }">
    <div class="loading-background">
    </div>
    <div class="loading-box">
        <div id="loading_hype_container" class="loading-object" aria-live="polite">
        </div>
    </div>
    <div class="loading-message heading-semi-bold">
        {{ message }}
    </div>
</div>
